import React from 'react';
import { useTheme } from '../App';

function Login() {
  const { theme } = useTheme();
  
  const handleLogin = () => {
    const clientId = process.env.REACT_APP_REDDIT_CLIENT_ID;
    const redirectUri = window.location.origin + '/callback';
    const scope = 'identity mysubreddits read';
    const state = 'your_random_string';

    const authUrl = `https://www.reddit.com/api/v1/authorize?client_id=${clientId}&response_type=code&state=${state}&redirect_uri=${encodeURIComponent(redirectUri)}&duration=permanent&scope=${encodeURIComponent(scope)}`;

    window.location.href = authUrl;
  };

  const asciiArt = `
╦═╗┌─┐┌─┐┌┬┐┌┬┐┬┌┬┐
╠╦╝├┤ ├─┤ ││ │││ │ 
╩╚═└─┘┴ ┴─┴┘─┴┘┴ ┴ 
                    
A Discrete Reddit Reader
    by Matt Batory`;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: '400px',
      color: theme.colors.foreground,
    }}>
      <pre style={{
        color: theme.colors.accentGreen,
        fontSize: '16px',
        lineHeight: '1.2',
        marginBottom: '40px',
        textAlign: 'center',
      }}>
        {asciiArt}
      </pre>
      
      <h2 style={{ color: theme.colors.accentCyan, marginBottom: '20px', fontSize: '18px' }}>
        Please log in to Reddit
      </h2>
      
      <button 
        onClick={handleLogin}
        style={{
          border: `1px solid ${theme.colors.accentGreen}`,
          color: theme.colors.accentGreen,
          padding: '10px 20px',
          fontSize: '14px',
        }}
      >
        Login with Reddit
      </button>
    </div>
  );
}

export default Login;